import React, { useState } from "react";
import Moment from "moment";

import { Button, DetailModal, detailModalDismissButtonProps } from "../ui";
import "../details/Sale.css";

const DEFAULT_PAYMENT_DESCRIPTION = "Payment received";

function PaymentModal(props) {
    const { addPayment, paymentModalShow, setPaymentModalShow } = props;
    const [payment, setPayment] = useState({
        date: Moment().format("YYYY-MM-DD"),
        amount: "",
        description: DEFAULT_PAYMENT_DESCRIPTION,
    });

    const handleUpdate = (event) => {
        const { name, value } = event.target;
        setPayment({
            ...payment,
            [name]: value,
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const descriptionTrimmed =
            payment.description != null ? String(payment.description).trim() : "";
        addPayment({
            ...payment,
            description:
                descriptionTrimmed !== "" ? descriptionTrimmed : DEFAULT_PAYMENT_DESCRIPTION,
        });

        setPayment({
            date: Moment().format("YYYY-MM-DD"),
            amount: "",
            description: DEFAULT_PAYMENT_DESCRIPTION,
        });

        setPaymentModalShow(false);
    };

    const handleClose = () => setPaymentModalShow(false);

    return (
        <DetailModal
            open={paymentModalShow}
            onClose={handleClose}
            title="Record Payment"
            subtitle="Add a payment to this sale"
            size="md"
            actions={
                <>
                    <Button type="button" {...detailModalDismissButtonProps} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" size="sm" form="payment-record-form">
                        Add
                    </Button>
                </>
            }
        >
            <p className="detail-section-title" style={{ marginBottom: "0.75rem" }}>
                Payment details
            </p>
            <form
                id="payment-record-form"
                className="Sale-orderform Sale-orderform-modal"
                onSubmit={handleSubmit}
            >
                <div className="Sale-payment-form-row">
                    <div className="Sale-order-form-input Sale-order-form-input-date">
                        <label htmlFor="payment-record-date">Date</label>
                        <input
                            id="payment-record-date"
                            name="date"
                            type="date"
                            value={payment.date}
                            onChange={handleUpdate}
                        />
                    </div>

                    <div className="Sale-order-form-input">
                        <label htmlFor="payment-record-description">Description</label>
                        <input
                            id="payment-record-description"
                            name="description"
                            type="text"
                            placeholder={DEFAULT_PAYMENT_DESCRIPTION}
                            value={payment.description}
                            onChange={handleUpdate}
                        />
                    </div>
                </div>

                <div className="Sale-payment-amount-field">
                    <label htmlFor="payment-record-amount">Amount received</label>
                    <input
                        id="payment-record-amount"
                        name="amount"
                        type="number"
                        min="0"
                        step="any"
                        placeholder="0.00"
                        value={payment.amount}
                        onChange={handleUpdate}
                        aria-describedby="payment-record-amount-hint"
                    />
                    <span id="payment-record-amount-hint" className="sr-only">
                        Dollar amount for this payment
                    </span>
                </div>
            </form>
        </DetailModal>
    );
}

export default PaymentModal;
